import { request } from "./request";

/** 查询全部修复产品列表 */
export function listAllRepairs() {
  return request("/repair/listAllRepairs", {
    method: "GET",
  });
}


export function addRepairs(data) {
  return request("/repair/addRepairs", {
    method: "POST",
    body: {
      repairName: data.repairName,
    },
  });
}

export function updateRepair(data) {
  return request("/repair/updateRepair", {
    method: "POST",
    body: {
      repairId: String(data.repairId),
      repairName: data.repairName,
    },
  });
}

export function deleteRepair(data) {
  return request("/repair/deleteRepair", {
    method: "POST",
    body: {
      repairId: String(data.repairId),
    },
  });
}
